<app-breadcrumb [parentName]="'Wsparcie'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group>
  <mat-tab label="Dane">
    <app-support-details-view *ngIf="!modify" [support]="support" (modifyClicked)="modify = true"></app-support-details-view>
    <app-support-add *ngIf="modify" [serviceTypeKeys]="supportObject.serviceType.key" [support]="support" (closeModification)="modify = false; loadSupport()"></app-support-add>
  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [support]="support"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
